import React from "react";
import { NavLink } from "react-router-dom";

const CoordinatorSidebar: React.FC = () => {
  return (
    <div className="sidebar p-3 fixed"
    
    >

      <nav className="d-flex flex-column gap-2">

        <NavLink to="/coordinator/dashboard" className="sidebar-link">
          Dashboard
        </NavLink>
         <NavLink to="/coordinator/enquiries" className="sidebar-link">
          My Enquiries
        </NavLink>
          <NavLink to="/coordinator/followups" className="sidebar-link">
          Follow Ups
        </NavLink>
          <NavLink to="/coordinator/fees" className="sidebar-link">
          Fees Collection
        </NavLink>
        <NavLink to="/coordinator/Batch" className="sidebar-link">
        Batch
</NavLink>

       

      

      
        <NavLink to="/coordinator/all-enquiries" className="sidebar-link">
  All Enquiries
</NavLink>
        
       

      </nav>
    </div>
  );
};

export default CoordinatorSidebar;